<template>
    <div class="payment-redirect-page">
        <div class="honor-logo">
            <img src="static/image/messageLogoNew.png"
                alt="">
        </div>
        <div class="hi-honor-text">Hi 荣耀小程序</div>
        <div class="redirect-btn"
            @click="backMiniProgram()">查看订单</div>
    </div>

</template>
<script>
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      toPage: '',
      orderNo: '',
    };
  },
  created() {
    this.toPage = this.$route.query.toPage || '';
    this.orderNo = this.$route.query.orderNo || '';
    console.log('当前页面的入参', this.$route.query);
  },
  methods: {
    backMiniProgram() {
      if (this.toPage === 'detail' && this.orderNo) {
        wx.miniProgram.redirectTo({
          url: `/subpackages/my/pages/orderDetail/order-detail?orderNo=${this.orderNo}&whetheSom=2&fromPage=paymentRedirect`,
        });
      } else if (this.toPage === 'appointmentDetail' && this.orderNo) {
        wx.miniProgram.redirectTo({
          url: `/subpackages/my/pages/appiont/appointmentDetails/appointment-details?argument=await&orderNo=${this.orderNo}&whetheSom=2&fromPage=paymentRedirect`,
        });
      } else {
        wx.miniProgram.reLaunch({
          url: '/pages/tabBar/index/index',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.payment-redirect-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url('../../../../static/image/messageBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .honor-logo {
    width: 26vw;
    height: 26vw;
    margin-top: 22.4vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .hi-honor-text {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 38px;
    font-weight: 400;
    margin-top: 3.9vh;
  }
  .redirect-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #256fff;
    border-radius: 36px;
    color: #fff;
    width: 53.3%;
    height: 4.5%;
    font-size: 15px;
    margin-top: 32.6vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/paymentRedirectPage/payment-redirect-page.vue